const { withRouter } = require("react-router-dom");
const PromoCodeForm = require("../../admin-promocodes/components/PromoCodeForm");
const React = require("react");
const T = require("prop-types");
const NavLink = require("react-router-dom").NavLink;

class PromoCodes extends React.Component {
    static propTypes = {
        isFetching: T.bool.isRequired,
        isSaving: T.bool.isRequired,
        promoCodes: T.array,

        deletePromoCode: T.func.isRequired,
        fetchSinglePromoCode: T.func.isRequired,
        updatePromoCode: T.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: parseInt(this.props.match.params.id)
        };
    }

    componentDidMount() {
        if (!this.getPromo()) {
            this.props.fetchSinglePromoCode(this.state.id);
        }
    }

    getPromo() {
        if (!this.props.promoCodes) {
            return null;
        }

        const index = this.props.promoCodes.findIndex(
            e => e.id === this.state.id
        );

        if (index === -1) {
            return null;
        }

        return this.props.promoCodes[index];
    }

    render() {
        const promo = this.getPromo();

        return (
            <div>
                <NavLink to="/admin/promocodes">← Back to promo codes</NavLink>
                <h2>Edit Promo Code</h2>

                {!promo || this.props.isFetching ? (
                    "Loading..."
                ) : (
                    <PromoCodeForm
                        isSaving={this.props.isSaving}
                        promo={promo}
                        showDelete={true}
                        delete={this.props.deletePromoCode}
                        save={this.props.updatePromoCode}
                    />
                )}
            </div>
        );
    }
}

module.exports = withRouter(PromoCodes);



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes-edit/components/PromoCodes.js